import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import './index.css'

// TODO: Add error boundary for production
// TODO: Consider React.StrictMode configuration

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
